// REACT
var React = require('react');
var ReactDOM = require('react-dom');

// LOCUSTUS
var empty = require('locutus/php/var/empty');
var isset = require('locutus/php/var/isset');
var count = require('locutus/php/array/count');
var round = require('locutus/php/math/round');
var array_slice = require('locutus/php/array/array_slice');

// OTHER LIBS
var Fuse = require('fuse.js');

const Members = React.createClass({
    getInitialState: function() {
      var amount = 25;

      var members = [];
      if(!empty(window.members)) {
        members = window.members;
      }

      var categories = [];
      if(!empty(window.categories)) {
        categories = window.categories;
      }

      var sortOptions = [0, "1 - D", "E - H", "I - P", "Q - T", "U - Z"];

      return {
          members: members, categories: categories, activeCategory: 0, page: 1, amount: amount, search: "", sortOption: '1', sortOptions: sortOptions
      };
    },
    changeAmount: function (e) {
        this.setState({amount: e.currentTarget.value});
        //console.log('Visible Product Amount Changed to: ', e.currentTarget.value);
    },
    changeCategory: function (e) {
        this.setState({activeCategory: e.currentTarget.value});
        this.changePage(1);
        this.changeSortOption('1');
        //console.log('Active Category Changed to: ', this.state.categories[e.currentTarget.value]);
    },
    changeSearch: function (e) {
        this.setState({search: e.currentTarget.value});
        this.changeSortOption(0);
        this.changePage(1);
        //console.log('Active Search Term Changed to: ', e.currentTarget.value);
    },
    changePageClick: function (e) {
        var page = parseInt($(e.currentTarget).data('page'));
        this.changePage(page);
    },
    changePage: function (page) {
        this.setState({page: page});
        //console.log('Active Page Changed to: ', page);
    },
    changeSortOptionClick: function (e) {
        var option = $(e.currentTarget).data('option');
        this.changeSortOption(option);
    },
    changeSortOption: function (option) {
        this.setState({sortOption: option});
        this.changePage(1);
    },
    resetButton: function (e) {
        this.changePage(1);
        this.changeSortOption('1');
        this.setState({search: ''});
        this.setState({activeCategory: 0});
    },
    render() {
        var visibleMembers = [];
        var availableMembers = [];
        var totalProductAmount;
        var page = parseInt(this.state.page) - 1;

        if(!empty(this.state.members)) {
            availableMembers = this.state.members;

            if(!empty(this.state.sortOption)) {
                var options = {
                    shouldSort: false,
                    threshold: 0,
                    keys: [
                        {
                            name: 'alphabeticalGroup',
                            weight: 1
                        }
                        //{
                        //    name: 'title',
                        //    weight: 0.9
                        //}
                    ]
                };
                var fuseSort = new Fuse(availableMembers, options);
                var option = this.state.sortOption.toString();
                availableMembers = fuseSort.search(option);
            }

            if(!empty(this.state.activeCategory)) {
                var options = {
                    shouldSort: true,
                    threshold: 0,
                    keys: [
                        {
                            name: 'category',
                            weight: 1
                        },
                        {
                            name: 'title',
                            weight: 0.9
                        }
                    ]
                };
                var fuseCategory = new Fuse(availableMembers, options);
                availableMembers = fuseCategory.search(this.state.categories[this.state.activeCategory]);
            }

            if(!empty(this.state.search)) {
                var options = {
                    shouldSort: true,
                    threshold: 0.2,
                    keys: [
                     {
                        name: 'title',
                        weight: 1
                      }
                      //  ,{
                      //  name: 'description',
                      //  weight: 0.9
                      //}
                    ]
                };
                var fuseSearch = new Fuse(availableMembers, options);
                availableMembers = fuseSearch.search(this.state.search);
            }

            var slicePos = parseInt(page) * parseInt(this.state.amount);
            visibleMembers = array_slice(availableMembers, slicePos, parseInt(this.state.amount));
        }

        totalProductAmount = count(availableMembers);
        var visibleFrom = parseInt(page*this.state.amount);
        var visibleTo = parseInt(page*this.state.amount+this.state.amount);

        if(visibleFrom == 0) {
            visibleFrom = 1;
        }

        if(totalProductAmount < visibleTo) {
            visibleTo = totalProductAmount;
        }

        var minPage = 1;
        var maxPage = Math.ceil(totalProductAmount / this.state.amount);

        var nextPage = Math.min(parseInt(this.state.page) + 1, maxPage);
        var previousPage = Math.max(parseInt(this.state.page) - 1, minPage);

        var pageAreaStart = 0;
        var pageAreaEnd = 0;

        if(maxPage > minPage) {
            pageAreaStart = Math.max(this.state.page-3, minPage);
            pageAreaEnd = Math.min(this.state.page+3, maxPage);
        } else {
            pageAreaStart = 1;
            pageAreaEnd = 1;
        }

        if((pageAreaEnd-pageAreaStart) < 7) {
            pageAreaEnd = Math.min(this.state.page+(7-(pageAreaEnd-pageAreaStart)), maxPage);
        }

        //console.log("Page Area: ", pageAreaStart, pageAreaEnd);

        var _this = this;

        //console.log(visibleMembers);

        return (
            <div>
                  <div className="panel panel-default">
                    <div className="grid-container">
                        <div className="reset-button">
                            <button type="button" onClick={this.resetButton}>Zurücksetzen</button>
                        </div>
                      <div className="category-selector">
                        <div className="select-wrapper">
                            <select className="form-control" value={this.state.activeCategory} onChange={this.changeCategory}>
                                {this.state.categories.map(
                                    function ( option, index ) {
                                        return (
                                            <option key={'option'+index} value={index}>
                                                {option}
                                            </option>
                                        );
                                    }
                                )}
                            </select>
                        </div>
                      </div>
                      <div className="search-input form-group">
                          <div>
                              <i className="fa fa-search" aria-hidden="true"></i>
                              <input type="text" className="form-control" placeholder="SUCHE" value={this.state.search} onChange={this.changeSearch} />
                          </div>
                      </div>
                    </div>
                    <div className="panel-header">
                        <ul>
                            {(function(_this){
                                var content = [];
                                for (var i = 1; i < _this.state.sortOptions.length; i++) {
                                    if(i == parseInt(_this.state.sortOption)) {
                                        content.push(<li key={"sortOption"+i} className="active disabled"><a>{_this.state.sortOptions[i]}</a></li>)
                                    } else {
                                        content.push(<li key={"sortOption"+i}><a data-option={i} onClick={_this.changeSortOptionClick}>{_this.state.sortOptions[i]}</a></li>)
                                    }
                                }
                                return content;
                            })(this)}

                        </ul>
                    </div>
                    <div className="panel-body">

                      <table className="table table-striped">
                        <tbody>

                            {visibleMembers.map(
                                function ( member, index ) {
                                    if(!empty(member['thumbnail'])) {
                                        return (
                                            <tr key={'member'+index}>
                                                <td><img src={member['thumbnail']} /></td>
                                                <td>
                                                    <span className="member-title">{member['title']}</span> <br/>
                                                    {/*<a className="openDetailsModal" data-member={member} target="_blank" href="#">Details</a>*/}
                                                    <a className="openDetailsModal" data-member={member} target="_blank" href={member['url']}>Details</a>
                                                </td>
                                            </tr>
                                        );
                                    }
                                    return (
                                        <tr key={'member'+index}>
                                            <td></td>
                                            <td>
                                                <span className="member-title">{member['title']}</span> <br/>
                                                {/*<a className="openDetailsModal" data-member={member} target="_blank" href="#">Details</a>*/}
                                                <a className="openDetailsModal" data-member={member} target="_blank" href={member['url']}>Details</a>
                                            </td>
                                        </tr>
                                    );
                                }
                            )}

                        </tbody>
                      </table>



                    </div>
                    <div className="panel-footer">

                      <div className="row" style={{marginTop: 3+"px"}}>
                        {/*
                        <div className="col-xs-12 col-md-3"  style={{textAlign: 'left', paddingTop:0+"px"}}>
                          <span>Zeige {visibleFrom} - {visibleTo} von {totalProductAmount} Artikeln</span>
                        </div>
                        */}
                        <div className="col-xs-12 col-md-offset-3 col-md-6" style={{textAlign: 'center'}}>
                          <ul className="pagination pagination-sm" style={{paddingTop:3+"px"}}>
                              <li className="prev"><a onClick={_this.changePage.bind(null, previousPage)}>«</a></li>

                            {(function(_this){
                                var content = [];
                                for (var i = pageAreaStart; i <= pageAreaEnd; i++) {
                                    if(i == _this.state.page) {
                                        content.push(<li key={"paginationButtonPage"+i} className="active disabled"><a>{i}</a></li>);
                                    } else {
                                        content.push(<li key={"paginationButtonPage"+i}><a data-page={i} onClick={_this.changePageClick}>{i}</a></li>);
                                    }
                                }
                                return content;
                            })(this)}

                              <li className="next"><a onClick={_this.changePage.bind(null, nextPage)}>»</a></li>
                          </ul>
                        </div>
                        {/*
                        <div className="col-xs-12 col-md-3" style={{textAlign: 'right'}}>
                            <select className="form-control" value={this.state.amount} onChange={this.changeAmount} style={{width: 'auto', display:'inline-block'}}>
                              <option value="25">25</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                            </select>
                            <span style={{marginLeft: 10+"px"}}>Artikel pro Seite</span>
                        </div>
                <div id="detailsModal">
                    <div className="modalContainer">
                        <span>Hola</span>
                        <object type="text/html" data="http://bremische-hafenvertretung.pm/member/alles-gut/" width="800px" height="600px" style={{overflow: 'auto', border: "5px ridge blue"}}>
                        </object>
                        <button className="closeDetailsModal">&times;</button>
                    </div>
                </div>
                        */}
                      </div>

                    </div>
                    <div id="detailsModal">

                    </div>
                  </div>
          </div>
        )
    }
});

module.exports = Members;

//$(window).ready(function() {
//    $('.openDetailsModal').click(function(e) {
//        var memberSelected = $(e.currentTarget).attr('data-member');
//        $('#detailsModal').show();
//    });
//
//    $('.closeDetailsModal').click(function() {
//        $('#detailsModal').hide();
//    })
//});